var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2888 42.2279C83.3306 64.8085 64.9157 83.2728 42.3351 83.2887C32.5826 83.2956 23.6244 79.896 16.5847 74.2143C14.7542 72.7369 14.6173 69.9935 16.2808 68.33L18.1427 66.4681C19.5654 65.0454 21.8367 64.8898 23.4129 66.1403C28.5994 70.2559 35.1632 72.7125 42.3054 72.7125C59.1127 72.7125 72.7124 59.1101 72.7124 42.3054C72.7124 25.4981 59.1101 11.8984 42.3054 11.8984C34.2386 11.8984 26.912 15.0331 21.472 20.15L29.8593 28.5373C31.5251 30.2031 30.3454 33.0511 27.9898 33.0511H3.96611C2.50575 33.0511 1.32202 31.8674 1.32202 30.407V6.38333C1.32202 4.02778 4.17004 2.84802 5.83581 4.51363L13.9948 12.6726C21.3525 5.64117 31.3245 1.32205 42.3054 1.32205C64.914 1.32205 83.247 19.6291 83.2888 42.2279ZM53.3921 55.2474L55.0154 53.1602C56.3602 51.4312 56.0487 48.9393 54.3196 47.5946L47.5936 42.3631V25.1189C47.5936 22.9284 45.8179 21.1527 43.6274 21.1527H40.9834C38.7929 21.1527 37.0172 22.9284 37.0172 25.1189V47.5359L47.8264 55.9431C49.5555 57.2878 52.0472 56.9765 53.3921 55.2474Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.7c14b0514db55f1f70df5c1079c67f7a.svg";
export { ForwardRef as ReactComponent };